import '../libs/bootstrap/bootstrap';
import { initMenu } from './components/menu';

document.addEventListener('DOMContentLoaded', () => {
    initMenu();
});
